import { Site } from './Site';
import { Model } from 'core/models';

export class AppUserSiteMapping extends Model {
  public appUserId?: number;
  public siteId?: number;
  public enabled?: boolean = true;
  public site?: Site;
}
